import React from 'react'

import { Box } from '@chakra-ui/react'

export type FilterIconProps = {
  color?: string
  colorScheme?: 'light' | 'dark'
  className?: string
}

export const FilterIcon = ({
  colorScheme,
  color,
  className,
}: FilterIconProps) => (
  <Box
    alignItems='center'
    color={
      color ??
      (colorScheme === 'light' ? 'light.icon.secondary' : 'icon.secondary')
    }
    display='flex'
  >
    <svg
      aria-label='Filter'
      className={className}
      fill='none'
      height='20'
      role='img'
      viewBox='0 0 20 20'
      width='20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5 10H15M2.5 5H17.5M7.5 15H12.5'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </svg>
  </Box>
)
